import * as React from 'react';

const SvgKebabVerticalIcon = props => (
  <svg
    fill="grey"
    strokeWidth="0"
    width="4"
    height="16"
    viewBox="0 0 4 19"
    xmlns="http://www.w3.org/2000/svg"
    className="mt-1 h-4"
    {...props}
  >
    <path d="M2.02502 18.35C1.60836 18.35 1.25419 18.2042 0.962524 17.9125C0.670858 17.6208 0.525024 17.275 0.525024 16.875C0.525024 16.475 0.670858 16.125 0.962524 15.825C1.25419 15.525 1.60002 15.375 2.00002 15.375C2.41669 15.375 2.76669 15.525 3.05002 15.825C3.33336 16.125 3.47503 16.475 3.47503 16.875C3.47503 17.275 3.33336 17.6208 3.05002 17.9125C2.76669 18.2042 2.42502 18.35 2.02502 18.35ZM2.02502 10.975C1.60836 10.975 1.25419 10.8292 0.962524 10.5375C0.670858 10.2458 0.525024 9.9 0.525024 9.5C0.525024 9.08333 0.670858 8.73333 0.962524 8.45C1.25419 8.16667 1.60002 8.025 2.00002 8.025C2.41669 8.025 2.76669 8.16667 3.05002 8.45C3.33336 8.73333 3.47503 9.075 3.47503 9.475C3.47503 9.89167 3.33336 10.2458 3.05002 10.5375C2.76669 10.8292 2.42502 10.975 2.02502 10.975ZM2.02502 3.625C1.60836 3.625 1.25419 3.47917 0.962524 3.1875C0.670858 2.89583 0.525024 2.54167 0.525024 2.125C0.525024 1.70833 0.670858 1.35417 0.962524 1.0625C1.25419 0.770833 1.60002 0.625 2.00002 0.625C2.41669 0.625 2.76669 0.770833 3.05002 1.0625C3.33336 1.35417 3.47503 1.70833 3.47503 2.125C3.47503 2.54167 3.33336 2.89583 3.05002 3.1875C2.76669 3.47917 2.42502 3.625 2.02502 3.625Z"/>
  </svg>
);

export default SvgKebabVerticalIcon;
